module.exports = __webpack_public_path__ + "static/media/man-gym-selected.be9fc525.png";